class Log {
  private DEBUG = false

  constructor(debug = false) {
    this.DEBUG = debug
  }

  enable (debug = true) {
    this.DEBUG = debug
  }

  log(...args: any) {
    if (!this.DEBUG) return
    console.log.apply(console, [...args])
  }

  info (...args: any) {
    if (!this.DEBUG) return
    console.info.apply(console, [...args])
  }

  warn (...args: any) {
    if (!this.DEBUG) return
    console.warn.apply(console, [...args])
  }

  error (...args: any) {
    if (!this.DEBUG) return
    console.error.apply(console, [...args])
  }
}

const DLog = new Log()

export default DLog
